import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUser } from '../utils/auth';

export default function ProtectedRoute({ children, allowedRoles = null }) {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && Array.isArray(allowedRoles)) {
    const user = getUser();
    const role = user?.role || null;

    if (!role || !allowedRoles.includes(role)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}